import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import { queryKeys } from '@/api/query-keys'
import type { ApiResponse } from '@/api/http/types'
import { normalizeSurveyPublicCode } from '../lib/survey-public-code'

const publicConfig = { skipUnauthorizedRedirect: true } as const

export type PublicSurveyCodeResolve = {
  instrumentId: string
  publicCode: string
}

export async function fetchPublicSurveyCode(code: string): Promise<PublicSurveyCodeResolve> {
  const normalized = normalizeSurveyPublicCode(code)
  if (!normalized) {
    throw new Error('Survey not found')
  }
  const { data } = await apiClient.get<ApiResponse<PublicSurveyCodeResolve>>(
    `/api/v1/public/survey-codes/${encodeURIComponent(normalized)}`,
    publicConfig,
  )
  if (!data.data?.instrumentId) {
    throw new Error('Survey not found')
  }
  return data.data
}

export function usePublicSurveyCode(code: string) {
  const normalized = normalizeSurveyPublicCode(code) ?? ''
  return useQuery({
    queryKey: queryKeys.publicSurveyCode.byCode(normalized),
    queryFn: () => fetchPublicSurveyCode(normalized),
    enabled: normalized.length > 0,
    retry: false,
  })
}
